
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {FeedUpdateSubscribeResponse} from './FeedUpdateSubscribeResponse';
import {FeedUpdateSubscriptionType} from './FeedUpdateSubscriptionType';
import {FieldModelFeedUpdateSubscriptionType} from './FeedUpdateSubscriptionType';

/**
 * FeedUpdateSubscribeRequest struct
 */
class FeedUpdateSubscribeRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!FeedUpdateSubscriptionType=} subscriptionType
   * @constructor
   */
  constructor (parent = new Request(), subscriptionType = new FeedUpdateSubscriptionType()) {
    super()
    super.copy(parent)
    this.SubscriptionType = subscriptionType
  }

  /**
   * Copy struct (shallow copy)
   * @this {!FeedUpdateSubscribeRequest}
   * @param {!FeedUpdateSubscribeRequest} other Other struct
   * @returns {!FeedUpdateSubscribeRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SubscriptionType != null) {
      this.SubscriptionType = FeedUpdateSubscriptionType.fromObject(other.SubscriptionType)
    } else {
      this.SubscriptionType = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!FeedUpdateSubscribeRequest}
   * @returns {!FeedUpdateSubscribeRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new FeedUpdateSubscribeRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new FeedUpdateSubscribeRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!FeedUpdateSubscribeRequest}
   * @param {!FeedUpdateSubscribeRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FeedUpdateSubscribeRequest)) {
      throw new TypeError('Instance of FeedUpdateSubscribeRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!FeedUpdateSubscribeRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SubscriptionType: ((this.SubscriptionType != null) ? this.SubscriptionType : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return FeedUpdateSubscribeRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!FeedUpdateSubscribeRequest} other Object value
   * @returns {!FeedUpdateSubscribeRequest} Created struct
   */
  static fromObject (other) {
    return new FeedUpdateSubscribeRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!FeedUpdateSubscribeRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return FeedUpdateSubscribeRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!FeedUpdateSubscribeRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 2068
  }
}

export { FeedUpdateSubscribeRequest };

/**
 * Fast Binary Encoding FeedUpdateSubscribeRequest field model
 */
class FieldModelFeedUpdateSubscribeRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.SubscriptionType = new FieldModelFeedUpdateSubscriptionType(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SubscriptionType.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SubscriptionType.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelFeedUpdateSubscribeRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 2068
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SubscriptionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SubscriptionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SubscriptionType.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @param {!FeedUpdateSubscribeRequest} fbeValue Default value, defaults is new FeedUpdateSubscribeRequest()
   * @returns {!FeedUpdateSubscribeRequest} FeedUpdateSubscribeRequest value
   */
  get (fbeValue = new FeedUpdateSubscribeRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @param {!FeedUpdateSubscribeRequest} fbeValue FeedUpdateSubscribeRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SubscriptionType.fbeSize) <= fbeStructSize) {
      fbeValue.SubscriptionType = this.SubscriptionType.get()
    } else {
      fbeValue.SubscriptionType = new FeedUpdateSubscriptionType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SubscriptionType.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @param {!FeedUpdateSubscribeRequest} fbeValue FeedUpdateSubscribeRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelFeedUpdateSubscribeRequest}
   * @param {FeedUpdateSubscribeRequest} fbeValue FeedUpdateSubscribeRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SubscriptionType.set(fbeValue.SubscriptionType)
  }
}

export { FieldModelFeedUpdateSubscribeRequest };

/**
 * Fast Binary Encoding FeedUpdateSubscribeRequest model
 */
class FeedUpdateSubscribeRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelFeedUpdateSubscribeRequest(this.buffer, 4)
  }

  /**
   * Get the FeedUpdateSubscribeRequest model
   * @this {!FeedUpdateSubscribeRequestModel}
   * @returns {!FieldModelFeedUpdateSubscribeRequest} model FeedUpdateSubscribeRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!FeedUpdateSubscribeRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!FeedUpdateSubscribeRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return FeedUpdateSubscribeRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!FeedUpdateSubscribeRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelFeedUpdateSubscribeRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!FeedUpdateSubscribeRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!FeedUpdateSubscribeRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!FeedUpdateSubscribeRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!FeedUpdateSubscribeRequestModel}
   * @param {!FeedUpdateSubscribeRequest} value FeedUpdateSubscribeRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!FeedUpdateSubscribeRequestModel}
   * @param {!FeedUpdateSubscribeRequest} value FeedUpdateSubscribeRequest value, defaults is new FeedUpdateSubscribeRequest()
   * @return {!object} Deserialized FeedUpdateSubscribeRequest value and its size
   */
  deserialize (value = new FeedUpdateSubscribeRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new FeedUpdateSubscribeRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new FeedUpdateSubscribeRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!FeedUpdateSubscribeRequestModel}
   * @param {!number} prev Previous FeedUpdateSubscribeRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { FeedUpdateSubscribeRequestModel };
FeedUpdateSubscribeRequest.__has_response = true;
FeedUpdateSubscribeRequest.__response_class = FeedUpdateSubscribeResponse;
